/**
 * @generated SignedSource<<1efb25d134a7ef428c2e589d6133165f>>
 * @relayHash 362268b1027ced6f997c96f5e4ae8449
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 686c68292a00b8d151484732c41f1dcadb2b6f18f1d2addc3fca4d4260768c96

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "686c68292a00b8d151484732c41f1dcadb2b6f18f1d2addc3fca4d4260768c96",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
